import React, { ReactNode, useState } from 'react';
import styles from './publicationDetailMobile.module.scss';
import Slider from '../../components/SliderTwo';
import Button from '../../components/Button';
import { Markup } from 'interweave';
import { images } from '../../constants/images';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { usePublicationDetail } from '../PublicationDetail/hooks/usePublicationDetail';
import { usePublicationLogic } from '../PublicationDetail/hooks/usePublicationLogic';
import { useWindowSize } from 'use-hooks';
import InformationLoader from '../PublicationDetail/Loader/Information/InformationLoader';
import DetailLoader from '../PublicationDetail/Loader/Detail/DetailLoader';
import { PublicationDetailProps } from '../../interfaces/components';
import { Skeleton } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CarBrandCharacteristics from '../CarBrandCharacteristics/CarBrandCharacteristics';

// Componentes reutilizables
import PublicationPriceIndicator from '../PublicationDetail/components/PublicationPriceIndicator/PublicationPriceIndicator';
import PublicationPromoBanners from '../PublicationDetail/components/PublicationPromoBanners/PublicationPromoBanners';
import ModalCharacteristics from '../PublicationDetail/components/ModalCharacteristics/ModalCharacteristics';

type PublicationDetailMobileProps = Pick<PublicationDetailProps, 'type' | 'publication' | 'loading' | 'children' | 'logoDealerships' | 'onLinzeCheckClick' | 'handleDealerLogoClick' | 'onAutoFinClick' | 'vehicleTypeSelected' | 'brand' | 'brandsDealerships' | 'selectedDealership' | 'setSelectedDealership' | 'selectedVersion' | 'setSelectedVersion' | 'setVehicleTypeReducer'>;

const PublicationDetailMobile: React.FC<PublicationDetailMobileProps> = ({
    brand,
    type = "publication",
    publication,
    loading,
    children,
    handleDealerLogoClick,
    logoDealerships,
    onLinzeCheckClick,
    onAutoFinClick,
    vehicleTypeSelected,
    brandsDealerships,
    selectedDealership,
    setSelectedDealership,
    selectedVersion,
    setSelectedVersion,
    setVehicleTypeReducer
}) => {
    const hookData = usePublicationDetail({ publication });
    const windowSize = useWindowSize();
    const {
        getMinPrice,
        selectedVehicleData,
        openAdditionalModal,
        setOpenAdditionalModal,
    } = usePublicationLogic({
        publication,
        brandsDealerships,
        selectedDealership,
        setSelectedDealership,
        selectedVersion,
        setSelectedVersion,
        setVehicleTypeReducer
    });

    const {
        addPointsInText,
        boldBetweenAsterisks,
        hasValidSuggestedPrices,
        hasValidSuggestedPricesPublication,
        getPriceCategory,
        getPriceCategoryPublication,
        getIndicatorPosition,
        getIndicatorPositionPublication,
        getPriceDifferenceMessage,
        isBonus,
    } = publication && !loading ? hookData : {
        addPointsInText: (text: string) => text,
        boldBetweenAsterisks: (text: string) => text,
        hasValidSuggestedPrices: false,
        hasValidSuggestedPricesPublication: false,
        getPriceCategory: () => "",
        getPriceCategoryPublication: () => "",
        getIndicatorPosition: () => 0,
        getIndicatorPositionPublication: () => 0,
        getPriceDifferenceMessage: () => "",
        isBonus: false,
    };
    const truncateText = (text: string, maxLength: number) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    }

    return (
        <div className={styles.container}>
            <div className={styles.sliderContainer}>
                <Slider
                    className={styles.slider}
                    sliderClassName={styles.sliderPreview}
                    thumbsClassName={styles.sliderThumbs}
                    type="thumbs"
                    options={
                        brand
                            ? (() => {
                                const selectedVehicle = publication?.vehicles?.find((v: any) => v._id === selectedVersion);
                                const allImages = [];

                                if (publication?.pictures && publication?.pictures.length > 0) {
                                    const mainImages = publication?.pictures.map((item: any, index: number) => (
                                        <img
                                            loading="lazy"
                                            key={`main-${index}`}
                                            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
                                            className={publication?.paused && styles.paused}
                                            alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`}
                                        />
                                    ));
                                    allImages.push(...mainImages);
                                }

                                if (selectedVehicle?.images && selectedVehicle.images.length > 0) {
                                    const vehicleImages = selectedVehicle.images.map((item: any, index: number) => (
                                        <img
                                            loading="lazy"
                                            key={`vehicle-${index}`}
                                            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
                                            className={publication?.paused && styles.paused}
                                            alt={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
                                        />
                                    ));
                                    allImages.push(...vehicleImages);
                                }

                                return allImages.length > 0 ? allImages : [1].map((_: any, index: number) => (
                                    <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
                                ));
                            })()
                            :
                            publication?.pictures && publication?.pictures.length > 0
                                ?
                                publication?.pictures.map((item: any, index: number) => (
                                    <img loading="lazy" key={index} src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url} className={publication?.paused && styles.paused} alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`} />
                                ))
                                :
                                [1].map((_: any, index: number) => (
                                    <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
                                ))
                    }
                    pagination
                    arrows={true}
                    perView={5}
                    spaceBetween={10}
                    loading={loading && (!Array.isArray(publication?.pictures) && !publication?.pictures?.length)}
                />
            </div>

            <div className={styles.mainContent}>
                {(loading && !publication?.id) ? (
                    <div className={`${styles.information} ${loading && styles.loader}`}>
                        <InformationLoader />
                    </div>
                ) : (
                    <div className={styles.information}>
                        {logoDealerships && logoDealerships !== undefined && logoDealerships !== null && (
                            <div className={brand ? styles.brandLogo : styles.dealerLogo} onClick={handleDealerLogoClick}>
                                <img src={logoDealerships} alt="Dealer logo" />
                            </div>
                        )}
                        {brand && (
                            <p className={styles.description}>
                                {selectedVehicleData?.year || publication?.year} | {addPointsInText(selectedVehicleData?.mileage || publication?.mileage)} km
                            </p>
                        )}
                        {!brand && (
                            <p className={styles.description}>{publication?.year} | {addPointsInText(publication?.mileage)} km</p>
                        )}
                        <h2 className={styles.title}>{publication?.title}</h2>
                        {publication?.version && (
                            <h3 className={styles.version}>{publication?.version}</h3>
                        )}
                        {brand && (
                            <>
                                <p className={styles.pricesBrand}>Desde ${addPointsInText(getMinPrice)} (*)</p>
                                <p className={styles.subTextPricesBrand}>(*) Precios referenciales</p>
                            </>
                        )}
                        {!brand && (
                            <p className={styles.price}>$ {addPointsInText(publication?.price)}</p>
                        )}

                        {!brand && (
                            <div className={styles.table}>
                                <div className={styles.comparaContainer}>

                                    <p className={styles.title}>Características</p>

                                </div>
                                <table>
                                    <tbody>
                                        {
                                            window.innerWidth <= 1024 && publication?.caracteristics ? publication?.caracteristics.map((item: any, index: number) => (
                                                <tr key={index} className={styles.item}>
                                                    <td className={styles.icon}>
                                                        <img src={`${item?.icon}`} alt={item?.name} />
                                                    </td>
                                                    <td className={styles.name}>{item?.name}</td>
                                                    <td className={styles.value}>
                                                        {
                                                            loading
                                                                ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                : item?.value ?? "-"
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                                :
                                                publication?.caracteristics && publication?.caracteristics.map((item: any, index: number) => {
                                                    if (index > 3) return null;
                                                    return (
                                                        <tr key={index} className={styles.item}>
                                                            <td className={styles.icon}>
                                                                <img src={`${item?.icon}`} alt={item?.name} />
                                                            </td>
                                                            <td className={styles.name}>{item?.name}</td>
                                                            <td className={styles.value}>
                                                                {
                                                                    loading
                                                                        ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                        : item?.value ?? "-"
                                                                }
                                                            </td>
                                                            <td className={styles.icon}>
                                                                <img src={`${publication?.caracteristics[index + 4]?.icon}`} alt={publication?.caracteristics[index + 4]?.name} />
                                                            </td>
                                                            <td className={styles.name}>{publication?.caracteristics[index + 4]?.name}</td>
                                                            <td className={styles.value}>
                                                                {
                                                                    loading
                                                                        ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                        : publication?.caracteristics[index + 4]?.value ?? "-"
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {brand && (
                            <CarBrandCharacteristics
                                publication={publication}
                                selectedVersion={selectedVersion}
                            />
                        )}
                        {brand && (
                            <>
                                <div className={styles.additionalCharacteristicsLink} onClick={() => setOpenAdditionalModal(true)}>
                                    Ver características adicionales
                                </div>
                                <ModalCharacteristics
                                    open={openAdditionalModal}
                                    onClose={() => setOpenAdditionalModal(false)}
                                    selectedVehicleId={selectedVersion || ''}
                                    publication={publication}
                                />
                            </>
                        )}

                        {publication?.chatgpt_description && (
                            <div className={styles.vehicleDescription}>
                                <div className={styles.descriptionHeader}>
                                    <p className={styles.title}>Descripción del vehículo</p>
                                    <p className={styles.subtitle}>
                                        <AutoAwesomeIcon className={styles.svg} />
                                        <span className={styles.textIA}>Generado por Linze IA</span>
                                    </p>
                                </div>
                                <p className={styles.descriptionText}>
                                    {publication.chatgpt_description}
                                </p>
                            </div>
                        )}

                        {type !== 'salePost' && (
                            publication?.sold ? (
                                <h3 className={styles.sold}>Vendido</h3>
                            ) : (
                                <div className={styles.priceIndicatorContainer}>
                                    {!brand && (
                                        <div className={styles.comparaContainer}>
                                            <p className={styles.region}>
                                                <LocationOnOutlinedIcon className={styles.locationIcon} />
                                                {truncateText(publication?.region, 36)}
                                            </p>
                                        </div>
                                    )}
                                    {loading ? (
                                        <ul className={styles.detail}>
                                            <DetailLoader />
                                        </ul>
                                    ) : (
                                        (publication?.detail && Array.isArray(publication?.detail)) && (
                                            <ul className={styles.detail}>
                                                <p className={styles.titleDetails}>Información provista por el vendedor</p>
                                                {publication?.detail?.map((item: any, index: number) => (
                                                    item?.key !== "bonus" && (
                                                        <li key={index}>
                                                            <img src={item?.icon} alt={item?.value} />
                                                            <Markup content={boldBetweenAsterisks(item?.value)} />
                                                        </li>
                                                    )
                                                ))}
                                            </ul>
                                        )
                                    )}

                                    <div className={styles.children}>{children}</div>
                                </div>
                            )
                        )}


                        {publication?.records?.length > 0 && type === "salePost" && (
                            <div className={styles.additionalDetails}>
                                {publication.records.map((item: any, index: number) => (
                                    <p key={index} className={styles.detailText}>
                                        <img src={`${item?.icon}`} alt={item?.name} /> {item.value}
                                    </p>
                                ))}
                            </div>
                        )}

                        <PublicationPriceIndicator
                            hasValidSuggestedPrices={hasValidSuggestedPricesPublication}
                            getPriceCategory={getPriceCategoryPublication}
                            getIndicatorPosition={getIndicatorPositionPublication}
                            getPriceDifferenceMessage={getPriceDifferenceMessage}
                            publication={publication}
                        />

                        {type === "salePost" && (
                            <div className={styles.buttonRow}>
                                <div className={styles.priceIndicatorWrapper}>
                                    {hasValidSuggestedPrices && (
                                        <div className={styles.priceIndicator}>
                                            <img
                                                src={
                                                    getPriceCategory() === "good"
                                                        ? images.checkVerde
                                                        : getPriceCategory() === "fair"
                                                            ? images.checkAmarillo
                                                            : images.checkRojo
                                                }
                                                alt="Indicador de precio"
                                                className={styles.priceIcon}
                                            />
                                            {getPriceCategory() === "good"
                                                ? "Buen precio"
                                                : getPriceCategory() === "fair"
                                                    ? "Precio justo"
                                                    : "Precio elevado"}
                                        </div>
                                    )}
                                </div>
                                <div className={styles.buttons}>
                                    <Button
                                        title="Negociar"
                                        onPress={() => console.log('Negociar')}
                                        tertiary
                                        disabled
                                        size='small'
                                        className={styles.button}
                                    />
                                    <Button
                                        title="Comprar"
                                        onPress={() => console.log('Comprar')}
                                        primary
                                        disabled
                                        size='small'
                                        className={styles.button}
                                    />
                                </div>
                            </div>
                        )}
                        <PublicationPromoBanners
                            type={type}
                            vehicleTypeSelected={vehicleTypeSelected}
                            onLinzeCheckClick={onLinzeCheckClick}
                            onAutoFinClick={onAutoFinClick}
                            disabled={type === "salePost"}
                        />


                        {type === "salePost" &&
                            <div className={styles.salePostButtons}>
                                {children}
                            </div>
                        }
                        {!loading && (publication?.certified || isBonus) && (
                            <div className={styles.certifiedFinancing}>
                                {publication?.certified && (
                                    <div className={`${styles.item} ${styles.certified}`}>
                                        <p>Vehículo verificado</p>
                                        <img src={images.check_blue} alt="vehículo verificado" />
                                    </div>
                                )}
                                {isBonus && (
                                    <div className={`${styles.item} ${styles.financingBonus}`}>
                                        <img src={images.financingBonus} alt="bono con financiamiento" />
                                        <p>Bono con financiamiento</p>
                                    </div>
                                )}
                            </div>
                        )}


                    </div>
                )}
            </div>
        </div>
    );
};

export default PublicationDetailMobile;
